import { requestResetPassword } from "../../transport/loginSignup";

export const resetPassword = (event) => {
    const wrapper = event.currentTarget.parentNode;
    const email = wrapper.querySelector(".comment--reset-email").value.trim();
    requestResetPassword({ email }).then(_resetSuccess(wrapper)).catch(_resetError(wrapper));
};

const _resetSuccess = (el) => () => {
    showResetError(el, false);
    el.querySelector(".comment--login--success").classList.remove("hidden");
    el.querySelector(".comment--login--errors").classList.add("hidden");
};

const _resetError = (el) => (errors) => {
    const errorMessage = errors.join(", ") || "Unknown Error";
    const successBox = el.querySelector(".comment--login--success");
    const errorBox = el.querySelector(".comment--login--errors");
    errorBox.classList.remove("hidden");
    errorBox.innerHTML = errorMessage;
    successBox.classList.add("hidden");
    showResetError(el, true);
};

const showResetError = (el, hasError) => {
    el.querySelector(".comment--reset-email").classList.toggle("required", hasError);
    el.querySelector(".requirements").classList.toggle("hidden", !hasError);
};
